<div class="container-fluid">
  <div mat-dialog-title>
    <div i18n>Add Custom Work Area</div>
  </div>
  <div mat-dialog-content>
    <form #areaForm="ngForm" (ngSubmit)="saveCustomAreaItem(areaForm)">
      <p i18n>Please enter product information for job custom area</p>


      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <label for="customItemDescription" i18n>Line Item Description</label>
            <input name="customItemDescription" type="Text" class="form-control" required maxlength="100"
                   placeholder="Enter Line Item Description"
                      [(ngModel)]="customItem.customItemDescription" #customItemDescription="ngModel"/> 
            <div [hidden]="!areaForm.submitted || customItemDescription.valid"
                 class="alert alert-danger" i18n>Enter a line ltem description</div>
          </div>
          <div class="control-wrapper">
            <label for="customItemProduct"i18n>Product</label>
            <input name="customItemProduct" type="Text" class="form-control" required maxlength="100"
                      placeholder="Enter Product Description"
                      [(ngModel)]="customItem.customItemProduct" #customItemProduct="ngModel"/>
            <div [hidden]="!areaForm.submitted || customItemProduct.valid"
                 class="alert alert-danger" i18n>Enter a product description</div>
          </div>
        </div>
      </div>
      <div class="row">
        
        <div class="container-fluid d-flex d-inline-block">
          <div class="col-sm-9">
            <button mat-button type="submit" class="mb-1 ml-1 btn btn-bidit-submit" i18n>Submit</button>
            <button mat-button type="button" (click)="onNoClick()" class="mb-1 ml-1 btn btn-bidit-cancel" i18n>Cancel</button>
          </div>
          <div class="col-sm-3 text-right">
            <button mat-button *ngIf="!hasWorkOrders && this.customItemId !== null" type="button" (click)="deleteCustomAreaItem(this.customItemId)" class=" mb-1 ml-1 btn btn-bidit-warn" i18n>Delete</button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>
